import MemoirCard from './MemoirCard';
import { CustomInput } from 'reactstrap';
const LC_Media = props => {
	let { active, setActiveMedia, memoir } = props;
	return (
		<div
			className={`lc_media pointer p-4 ${active ? 'active' : ''}`}
			onClick={() => {
				setActiveMedia();
				props.setCollaboratives(memoir.collaborators);
				props.setMemoirID(memoir.id);
			}}
		>
			<div className='w-100 position-relative'>
				<MemoirCard
					mem={memoir}
					showMenu={false}
					toggleDropDown={() => {}}
					height='130px'
					linkable={false}
					settings={false}
				/>
				{/* <img src={memoir.tempFiles.length > 0 ? memoir.tempFiles[0].media_files[0] : Media} className="media_img" height="250px" /> */}
				<div
					className={`position-absolute ${
						active ? 'd-block' : 'd-none'
					}`}
					style={{ top: 10, left: 10 }}
				>
					<CustomInput
						type='checkbox'
						id='exampleCustomCheckbox'
						checked={true}
						label=''
					/>
				</div>
			</div>
			{/* <h4 className="mt-3">{memoir.memoir_title}</h4>
        <p style={{ fontSize: 18 }} className="mt-2">
          {memoir.introduction}
        </p> */}
		</div>
	);
};

export default LC_Media;
